import { IconButton, Typography } from '@mui/material'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import React from 'react'

export default function EmptyComponent({message}){
    return(
    <>
        <Typography variant="body2" color="text.secondary">
            {message}
        </Typography>
        <SentimentVeryDissatisfiedIcon/>
    </>
    )
}